// extracted by mini-css-extract-plugin
export default {"wrapper":"union_wrapper__eTpuB","relation":"union_relation__w742R","date":"union_date__Clvy+"};